import { useCallback, useState } from 'react';
import { useBoolState } from '../useHook';
/**
 * プロジェクト事例の挙動を制御するuse
 * @param rawProjectCareers
 * @returns {*}
 */
export const useProfessionalUnitProjectCareerItems = (rawProjectCareers) => {
    const { boolState: isShowModal, changeFalse: hideModal, changeTrue: showModal, } = useBoolState(false);
    const [currentProjectCareer, changeCurrentProjectCareer] = useState();
    /**
     * もっと読むのクリックイベント
     * @type {(function(*): void)|*}
     */
    const onClickReadMore = useCallback((e) => {
        const { value } = e.currentTarget;
        const id = parseInt(value, 10);
        const projectCareer = rawProjectCareers.find((v) => v.id === id);
        if (projectCareer) {
            changeCurrentProjectCareer(projectCareer);
            showModal();
        }
    }, [changeCurrentProjectCareer, rawProjectCareers, showModal]);
    return {
        currentProjectCareer,
        hideModal,
        isShowModal,
        onClickReadMore,
        showModal,
    };
};
export const useProfessionalUnitProjectCareers = {
    useProfessionalUnitProjectCareerItems,
};
